// Utility to get the API URL dynamically
// This works for both development and production deployments

export const getApiUrl = () => {
  // In production builds, use the current domain
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  
  // In development, use environment variable or fallback
  return process.env.REACT_APP_API_URL || 'http://localhost:5001';
};

// For backwards compatibility, export as default
export default getApiUrl;